
import Vue from 'vue'
import store from 'store'

/**
 * Here, we take all of the independent
 * Vuex modules laid out in the store
 * subdirectories and create a single Vuex
 * store that includes all of them.
 */
export default el => Promise.all([
  enqueueModule('product-card.vue')
]).then(() => new Vue({
  el,
  store,
  data () {
    return {
    }
  }
}))
